import { SellerCenterAccountApiClient, PublicSellerCenterAccountApiClient, SellerCenterSellerApiClient } from '@/apis';

export default {
  login (params, gcResponse, options = {}) {
    const url = 'user/login';
    return PublicSellerCenterAccountApiClient.post(url, params,
      { headers: { 'X-G-Login-Invisible-Recaptcha': gcResponse }, ...options });
  },

  changePassword (params, gcResponse) {
    return SellerCenterAccountApiClient.put('change-password', params,
      { headers: { 'X-G-Login-Invisible-Recaptcha': gcResponse } }
    );
  },
  updatePassword (options, gcResponse) {
    const url = 'update-password';
    return PublicSellerCenterAccountApiClient.post(url, options,
      { headers: { 'X-G-Login-Invisible-Recaptcha': gcResponse } }
    );
  },
  updatePasswordAndLogin (options, gcResponse) {
    const url = 'update-password-by-phone';
    return PublicSellerCenterAccountApiClient.post(url, options,
      { headers: { 'X-G-Login-Invisible-Recaptcha': gcResponse } }
    );
  },
  candidateUpdatePassword (options, gcResponse, onboardingToken) {
    const url = 'update-candidate-password';
    return PublicSellerCenterAccountApiClient.post(url, options, {
      headers: {
        'X-G-Login-Invisible-Recaptcha': gcResponse,
        'x-onboarding-execute-token': onboardingToken,
      },
    }
    );
  },
  forgotPassword (data, headers) {
    return PublicSellerCenterAccountApiClient.post('reset-password', data, headers);
  },

  getRoles () {
    return SellerCenterAccountApiClient.get('roles');
  },
  getStores () {
    return SellerCenterSellerApiClient.get('seller/stores');
  },
  getUsers (options) {
    return SellerCenterAccountApiClient.get('users', options);
  },
  deleteUser (options) {
    return SellerCenterAccountApiClient.delete(`users/${options.params.id}`);
  },
  updateUserStatus (data, options) {
    const { id } = options.params;
    delete options.params.id;
    return SellerCenterAccountApiClient.put(`users/${id}/update-status`, data, options);
  },
  editUser (data, options) {
    const { id } = options.params;
    delete options.params.id;
    return SellerCenterAccountApiClient.patch(`users/${id}`, data, options);
  },
  addUser (data, options) {
    return SellerCenterAccountApiClient.post(`users`, data, options);
  },

  getAddresses (options) {
    return SellerCenterSellerApiClient.get('seller/addresses', options);
  },
  getAddressesV2 (options) {
    return SellerCenterSellerApiClient.get('seller/addresses/v2', options);
  },
  getIntegrationInformation () {
    return SellerCenterSellerApiClient.get('seller/integration');
  },
  getIntegrationInformationV2 () {
    return SellerCenterSellerApiClient.get('seller/integration/v2');
  },
  renewIntegrationInformation ({ apiKey, apiSecret }) {
    const token = window.btoa(`${apiKey}:${apiSecret}`);
    return SellerCenterSellerApiClient.patch('seller/integration', { token });
  },
  renewIntegrationInformationV2 ({ apiKey, apiSecret }) {
    const token = window.btoa(`${apiKey}:${apiSecret}`);
    return SellerCenterSellerApiClient.put('seller/integration/v2', { token });
  },
  getUserInformation () {
    return SellerCenterAccountApiClient.get('users/info');
  },
  getAccountInformationV2 () {
    return SellerCenterSellerApiClient.get('seller/info/v2');
  },
  updateSellerInfo (payload) {
    return SellerCenterSellerApiClient.put('seller/info', payload);
  },
  getSellerContacts () {
    return SellerCenterSellerApiClient.get('seller/contacts');
  },
  getBankInformation () {
    return SellerCenterSellerApiClient.get('seller/finance-info');
  },
  updateIban (data, options) {
    return SellerCenterSellerApiClient.put('seller/iban', data, options);
  },
  getCities (options) {
    return SellerCenterAccountApiClient.get('address/cities', options);
  },
  getDistricts (cityId, options) {
    return SellerCenterAccountApiClient.get(`address/cities/id/${cityId}/districts`, options);
  },
  getHolidaySetting (options) {
    return SellerCenterSellerApiClient.get(`seller/holiday-mode`, options);
  },
  updateHolidaySetting (data, options) {
    return SellerCenterSellerApiClient.put(`seller/holiday-mode`, data, options);
  },
  updateHolidaySettingV2 (data, options) {
    return SellerCenterSellerApiClient.put(`seller/holiday-mode/v2`, data, options);
  },
  getSellerLockdownOptions (options) {
    return SellerCenterSellerApiClient.get(`seller/lockdown-options`, options);
  },
  updateSellerLockdownOptions (data, options) {
    return SellerCenterSellerApiClient.put(`seller/lockdown-options`, data, options);
  },

  updateAddress (data, options) {
    const { id } = options.params;
    delete options.params.id;
    return SellerCenterSellerApiClient.put(`seller/addresses/${id}`, data, options);
  },

  updateAddressV2 (data, options) {
    return SellerCenterSellerApiClient.put(`seller/addresses/v2`, data, options);
  },
  createAddress (data, options) {
    return SellerCenterSellerApiClient.post(`seller/addresses`, data, options);
  },
  resetPhone (data, options) {
    return SellerCenterAccountApiClient.post(`users/reset-phone`, data, options);
  },
  resetPhoneValidateOtp (data, options) {
    return SellerCenterAccountApiClient.post(`users/reset-phone/otp/validate`, data, options);
  },
  updateUserPhone (data, options) {
    return SellerCenterAccountApiClient.put(`users/phone`, data, options);
  },
  verifyEmail (options) {
    return SellerCenterAccountApiClient.post(`verify-email`, {}, options);
  },
  sendOtpUpdateEmail (data, options) {
    return SellerCenterAccountApiClient.post(`change-email`, data, options);
  },
  validateOtpUpdateEmail (data, options) {
    return SellerCenterAccountApiClient.post(`change-email/validate`, data, options);
  },
  reFetchGibDetail () {
    return SellerCenterSellerApiClient.get('/seller/gib-detail/refetch');
  },
};
